import { type Aperture, type ComponentEffect, toRender } from "refract-rxjs";
import { combineLatest } from "rxjs";
import { filter, map, startWith } from "rxjs/operators";

import { type GetOrganicStatsQuery } from "../api/queries";
import { ejectRetentionTotalValue } from "../filters";

export interface RetentionTotalEffectInput {
    data: GetOrganicStatsQuery | undefined;
    loading: boolean;
}

export interface RetentionTotalEffectOutput {
    dauOverWau: number;
    dauOverMau: number;
}

const defaults = { dauOverWau: 0, dauOverMau: 0 };

export const retentionTotalEffect: Aperture<RetentionTotalEffectInput, ComponentEffect<RetentionTotalEffectOutput>> = ({
    observe,
}) => {
    const data$ = observe<GetOrganicStatsQuery | undefined>("data");
    const loading$ = observe<boolean>("loading");

    return combineLatest([data$, loading$]).pipe(
        filter((values): values is [GetOrganicStatsQuery, boolean] => {
            const [data, loading] = values;
            return !loading && data !== undefined && !!data.getMyLensesOrganicStats;
        }),
        map(([{ getMyLensesOrganicStats }]) => ({
            ...ejectRetentionTotalValue(getMyLensesOrganicStats.responseEntryList),
        })),
        startWith(defaults),
        map(({ dauOverWau, dauOverMau }) =>
            toRender<RetentionTotalEffectOutput>({
                dauOverWau,
                dauOverMau,
            }),
        ),
    );
};
